<template>
  <header>
    <NavBar />
    <div v-if="authorizationNeeded" id="google-auth" class="bg-warning p-2 text-center">
      Google authorization is needed for Auger. Please
      <a @click="startGoogleAuthorization">authorize now</a>.
    </div>
  </header>
</template>

<script setup lang="ts">
import { toast } from "vue-sonner"
import { storeToRefs } from "pinia"
import NavBar from "@/components/app/NavBar.vue"
import { useGoogle } from "@/composables/useGoogle"
import { client } from "@/init/apollo"
import { useGoogleStore } from "@/stores/google"

const { authorize } = useGoogle({ client, toast })

const { authorizationNeeded } = storeToRefs(useGoogleStore())

function startGoogleAuthorization() {
  authorize()
}
</script>

<style>
#app > header {
  background-color: var(--auger-dark);
  min-height: 84px;
}
@media screen and (max-width: 782px) {
  #app > header {
    min-height: auto;
  }
}
</style>
